import React, { useMemo } from 'react';
import { PhonicsClassStatus, PhonicsLessonGroup } from '@/api/types';
import { getLessonByIdFromGroups } from '@/utils/lessons';
import { StudentDecodableBookPod } from './StudentDecodableBookPod';

interface StudentDecodableBooksListProps {
  lessonGroups?: Array<PhonicsLessonGroup>;
  phonicsClass: PhonicsClassStatus;
}

export const StudentDecodableBooksList = ({
  lessonGroups,
  phonicsClass,
}: StudentDecodableBooksListProps) => {
  const bookIds: Array<string> | undefined = useMemo(() => {
    if (!lessonGroups || !phonicsClass) {
      return;
    }

    const result = phonicsClass.classLessonStatuses.flatMap(
      (classLessonStatus) => {
        const lesson = getLessonByIdFromGroups(
          classLessonStatus.lessonId,
          lessonGroups,
        );

        return lesson?.decodableBookIds || [];
      },
    );

    return Array.from(new Set(result.reverse()));
  }, [lessonGroups, phonicsClass]);

  return (
    bookIds && (
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3">
        {bookIds.map((bookId) => (
          <StudentDecodableBookPod key={bookId} bookId={bookId} />
        ))}
      </div>
    )
  );
};
